// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const getGeoCodeFromAddress = (address: string) =>
    new Promise<google.maps.GeocoderResult[]>((resolve, reject) => {
        if (address && address.trim()) {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address }, (results: google.maps.GeocoderResult[], status: any) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    resolve(results);
                } else {
                    reject(status);
                }
            });
        } else {
            reject(google.maps.GeocoderStatus.ZERO_RESULTS);
        }
    });

export const getGeoCodeFromLatLng = (lat: number, lng: number) =>
    new Promise<google.maps.GeocoderResult[]>((resolve, reject) => {
        const location = new google.maps.LatLng(lat, lng);
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: "", location }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
                resolve(results);
            } else {
                reject(status);
            }
        });
    });
